import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { ChannelSelectorModule } from 'src/app/components/channel-selector/channel-selector.module';
import { CustomFieldsModule } from 'src/app/components/custom-fields/custom-fields.module';
import { SlackTextEditorComponent } from 'src/app/components/slack-text-editor/slack-text-editor.component';
import { SupportStepsModule } from 'src/app/components/support-steps/support-steps.module';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { ColonToEmojiPipe } from '../../../pipes/colonToEmoji.pipe';
import { AutoresponderComponent } from '../../components/autoresponder/autoresponder.component';

import { AdminSettingsRoutingModule } from './admin-settings-routing.module';
import { AdminSettingsComponent } from './admin-settings.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdminSettingsRoutingModule,
    SharedPipesModule,
    SupportStepsModule,
    NgxTippyModule,
    ChannelSelectorModule,
    AutoresponderComponent,
    SlackTextEditorComponent,
    CustomFieldsModule,
    ColonToEmojiPipe,
  ],
  declarations: [AdminSettingsComponent],
})
export class AdminSettingsModule {}
